import React from 'react';

const Icon = ({ size = '17', fill = '#3F68E0', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 17 17" fill="none" {...other}>
            <path
                d="M8.788 3.218a.5.5 0 0 1 .357.15l.25.256c-.066-.066.935.946 3.32.946.091 0 .184-.001.276-.005h.002l.359-.012a.501.501 0 0 1 .516.5V9.38c0 .712-.13 1.622-.832 2.546-.692.912-1.902 1.787-3.954 2.524l-.002.001-.125.044a.501.501 0 0 1-.336 0l-.125-.044c-2.052-.739-3.263-1.613-3.956-2.525-.701-.924-.832-1.834-.832-2.546V5.053a.501.501 0 0 1 .517-.5l.357.012h.003c.092.004.185.005.277.005 2.415 0 3.379-1.017 3.297-.924l.019-.021.256-.259.077-.063a.5.5 0 0 1 .28-.085Zm-.003 1.199C8.407 4.735 7.171 5.57 4.86 5.57l-.154-.003v3.814c0 .574.1 1.246.628 1.941.533.702 1.54 1.478 3.453 2.172 1.914-.694 2.921-1.47 3.454-2.172.527-.695.627-1.367.627-1.941V5.567l-.154.003c-2.332 0-3.578-.863-3.929-1.153Zm.58 3.796h1.145L8.219 11.82V9.501H7.073l2.291-3.865v2.577Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
